<template>
    <div class="container-fluid">
        <div class="row">
            <sidebar></sidebar>
            <!-- MAIN CONTENT start -->
            <main role="main" class="col-12 col-sm-9 ml-sm-auto col-lg-10">
              <div class="row">
                  <div class="col-12 mb-5">
                      <app-header></app-header>
                      <page-header :page-title="pageData.title" :breadcrumb="pageData.breadcrumb"></page-header>
                  </div>
              </div>
              <section class="row application-form-container b-30 bg-light align-content-start justify-content-center px-0 mx-0 px-xl-5 mx-xl-5 mt-lg-2 mb-3">
                <div class="col-12 col-md-8 col-lg-12">
              
 
                    <div class="row justify-content-center">

                        <div class="col-12  col-lg-6" v-for="application_group in application_groups">

                                <button style="height: 100px;" type="button" @click="chooseApplicationGroup(application_group.application_groupID)" class="btn btn-outline-danger mt-2 mb-2 w-100"><span style="font-size: 15px;">{{helpers.getLocalizedField(application_group, 'application_group')  }}</span></button>

                        
  


                        </div>
                   


                    </div>

 


                       


                
                </div>
                <div class="w-100"></div>
             
              </section>
            </main>
        </div>
    </div>
</template>
<script>
import sidebar from '../components/navbar/sidebar';
import appHeader from '../components/app-header';
import pageHeader from '../components/page/page-header';
import ApplicationForm from '../components/applications/application-form';
import Multiselect from 'vue-multiselect';
import ApplicationResource from '../api/applicationResource';
import { mapGetters } from 'vuex';

const applicationResource = new ApplicationResource();

export default {
  name:'new-application',
  components: { sidebar, appHeader, pageHeader, Multiselect, ApplicationForm },

  computed: {
    pageData() {
      return {
          title: this.$t('applications.new.title'),
          breadcrumb: [{
          icon: '',
          title: this.$t('home.title'),
          link: '/',
          isActive: false,
          },
            {
              icon: '',
              title: this.$t('applications.title'),
              link: '/my-applications',
              isActive: false,
            },
            {
              icon: '',
              title: this.$t('applications.new.title'),
              link: '/my-applications/chooseGroup',
              isActive: true,
            }],
      };
      },
    ...mapGetters({
      locale: 'language/locale'
    })
  },

  watch:{

    chosenApplicationGroupID(val){
      
          this.chosenType=null
           this.applicationType=null

    },
 

  },

  data() {
      return {
 
        application_groups:[], 
      }
  },

  mounted() {
 


 applicationResource.applicationGroups()
      .then(response => {
        this.application_groups = response.data;
      })



  },

  methods: {
    


    chooseApplicationGroup(applicationGroupID){
        window.location.href='/my-applications/new/'+applicationGroupID
       
    }
  }
}
</script>
 
